import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets.app/images/play.svg'


const _hoisted_1 = {
  key: 0,
  class: "notification v-fade"
}
const _hoisted_2 = { class: "notification__content" }
const _hoisted_3 = {
  key: 0,
  class: "notification__close-btn"
}
const _hoisted_4 = { class: "notification__text-box" }
const _hoisted_5 = { class: "notification__title" }
const _hoisted_6 = { class: "notification__text" }
const _hoisted_7 = { class: "notification__btn-box" }

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationBox',
  props: {
    hideCloseButton: { type: Boolean }
  },
  setup(__props: any) {



const visible = ref(true)

function hide(): void {
  visible.value = false
}

return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            (!__props.hideCloseButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("a", {
                    class: "notification__close",
                    onClick: hide
                  }, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("span", { class: "notification__close-icon iconfont iclose" }, null, -1)
                  ]))])
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "icon", {}, () => [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "notification__play-icon" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                })
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, [
                _renderSlot(_ctx.$slots, "title", {}, () => [
                  _cache[2] || (_cache[2] = _createTextVNode(" Introducing Podcasts: Meet the new content platform available now on Shortform! ", -1))
                ])
              ]),
              _createElementVNode("p", _hoisted_6, [
                _renderSlot(_ctx.$slots, "text", {}, () => [
                  _cache[3] || (_cache[3] = _createElementVNode("a", { href: "#" }, "Lorem ipsum dolor", -1)),
                  _cache[4] || (_cache[4] = _createTextVNode(" Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus a laoreet habitasse sed rutrum urna. Ut quam eget aliquam integer ut orci proin facilisis. ", -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "link", {}, () => [
                _cache[5] || (_cache[5] = _createElementVNode("a", {
                  href: "#",
                  class: "btns btns--large"
                }, "Learn More", -1))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})